/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Search from "../../assets/images/icon-search.svg";
import Arrow from "../../assets/images/pagination_arrow.svg";
import { TableRowPlaceholder } from "../../components/TableRowPlaceholder/TableRowPlaceholder";
import { useAppSelector } from "../../hooks/hooks";
import { ALL } from "../../utils/Constants";
import {
  callRequest,
  exportData,
  filters,
  IntraStatementList,
  paginationElemnts,
  transactionTypes,
} from "./hook/ScreenHelper";
import Moment from "react-moment";
// import { hasAnyGroupAdminRole } from "../../utils/Helpers";

export const Statements: React.FC = () => {
  const { t } = useTranslation();
  const { loading } = useAppSelector((state) => state.settings);

  const [page, setPage] = useState<number>(1);
  const [inputs, setInputs] = useState<filters>({ page });
  const [filters, setFilters] = useState<filters>({
    page,
    transactionType: ALL,
    loadAllDocuments: false,
  });
  const [data, setData] = useState<IntraStatementList>(null);
  const [timer, setTimer] = useState(null);
  // const isAdmin = hasAnyGroupAdminRole([GroupAdmin.FINANCE_ADMIN]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // if(isAdmin){
      callRequest(setData, filters);
    // }
  }, [page, filters]);

  const changePage = (currentPage: number) => {
    setFilters({ ...filters, page: currentPage });
    setPage(currentPage);
  };

  const searchInputChanged = (value) => {
    setPage(1);
    setInputs({ ...inputs, search: value, page: 1 });
    setFilters({ ...filters, search: value, page: 1 });
    clearTimeout(timer);
    if(value === ''){
      return;
    }

    const newTimer = setTimeout(() => {
      callRequest(setData, filters, { ...filters, search: value });
    }, 500);

    setTimer(newTimer);
  };

  const changeStatementStatus = (data) => {
    setPage(1);
    let filterPayload = { ...filters, transactionType: data, page: 1 };
    setFilters(filterPayload);
    callRequest(setData, filterPayload);
  };

  const clearText = () =>{
    setData(null)
    searchInputChanged("");
  }
  
  return (
    <>
      <div className="box_container">
        <div className="row g-3">
          <div className="col-md-12">
            <div className="row table-header mb-3 text-end">
              <div className="dropdown d-flex justify-content-end">
                <button
                  className="btn bg-gradient-dark mb-0 dropdown-toggle col-12 col-sm-6 col-md-4 col-lg-2"
                  data-bs-toggle="dropdown"
                  disabled={ inputs?.search === '' && !(data && data?.items.length > 0)}
                >
                  {t("pages.statements.trnTypes." + filters.transactionType)}
                </button>
                <ul className="dropdown-menu">
                  {transactionTypes.map((txnType) => {
                    return (
                      <li>
                        <a
                          className="dropdown-item"
                          onClick={() => changeStatementStatus(txnType)}
                        >
                          {t("pages.statements.trnTypes." + txnType)}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>

            <div className="row table-header">
              <div className="col-sm-12 col-md-11 mb-2">
                <div className="input-group search-input align-items-center">
                  <span className="input-group-text">
                    <img alt="" src={Search} />
                  </span>
                  <input
                    type="text"
                    className="form-select"
                    placeholder={t("inputs.statements.search_input_placeholder_new")}
                    onChange={(e) => searchInputChanged(e.target.value)}
                    value={inputs.search}
                  />
                  {inputs.search && (
                    <button
                      type="button"
                      className="btn-close ps mx-3"
                      aria-label="Close"
                      onClick={clearText}
                    ></button>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-md-1 mb-2">
                <div
                  className="d-flex align-items-center justify-content-end"
                  role="toolbar"
                  aria-label="Toolbar with button groups"
                >
                  <div
                    className="btn-group"
                    role="group"
                    aria-label="First group"
                  >
                    {/* <button
                      className="btn bg-gradient-dark d-flex-center"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasExample"
                      aria-controls="offcanvasExample"
                      data-bs-placement="top"
                      title="Filter"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        width="19"
                        height="19"
                      >
                        <path d="M3 4c0-.55.45-1 1-1h16c.55 0 1 .45 1 1 0 .22-.07.42-.2.58L14 13.51v6.75c0 .47-.35.9-.82.98-.58.11-1.15-.29-1.15-.89v-6.84L3.2 4.58A.996.996 0 013 4z" />
                      </svg>
                    </button> */}
                  </div>

                  <div
                    className="btn-group"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      className="btn bg-gradient-dark d-flex-center"
                      onClick={() => exportData(filters, t)}
                      type="button"
                      data-bs-toggle="offcanvas"
                      aria-controls="offcanvasExample"
                      data-bs-placement="top"
                      title="Download"
                      disabled={!(data && data?.items.length > 0)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        fill="currentColor"
                        className="bi bi-download"
                        viewBox="0 0 16 16"
                      >
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 ">
            <div className="table-responsive" style={{ minHeight: "25rem" }}>
              <table className="table table-hover my-table">
                {data && data?.items.length > 0 && (
                  <thead>
                    <tr>
                      <th scope="col" style={{ width: 100 }}>
                        {t("inputs.statements.postDate")}
                      </th>
                      <th scope="col">{t("inputs.statements.channel")}</th>
                      <th scope="col">{t("inputs.statements.refNum")}</th>
                      <th scope="col">{t("inputs.statements.narr1")}</th>
                      <th scope="col">{t("inputs.statements.narr2")}</th>
                      <th scope="col">{t("inputs.statements.narr3")}</th>
                      <th scope="col">{t("inputs.statements.partTrnType")}</th>
                      <th scope="col">
                        {t("inputs.statements.transactionAmount")}
                      </th>
                      <th scope="col">
                        {t("inputs.statements.closingBalanceAmount")}
                      </th>
                    </tr>
                  </thead>
                )}
                <tbody>
                  {loading && <TableRowPlaceholder />}

                  {data?.items?.map((item, key) => (
                    <tr key={item.refNum}>
                      <td style={{ minWidth: 140 }}>
                        <Moment format="YYYY-MM-DD HH:mm:ss" tz="Asia/Riyadh">
                          {item.postDate + " " + item.postingTime}
                        </Moment>
                      </td>
                      <td>{item.channel}</td>
                      <td>{item.refNum}</td>
                      <td>{item.narr1}</td>
                      <td>{item.narr2}</td>
                      <td>{item.narr3}</td>
                      <td
                        className={
                          item.partTrnType === "DEBIT"
                            ? "text-danger"
                            : "text-success"
                        }
                      >
                        {t("pages.statements.trnTypes." + item.partTrnType)}
                      </td>
                      <td>
                        {item.transactionAmount} {item.transactionCurrency}
                      </td>
                      <td>
                        {item.closingBalanceAmount}{" "}
                        {item.closingBalanceCurrency}
                      </td>
                    </tr>
                  ))}
                    {data?.items.length <= 0 && (
                    <div className="text-center text-muted">
                      No data available
                    </div>
                  )}
                </tbody>
              </table>
            </div>
            {data && data?.items.length > 0 && <div className="col-md-12 ">
              <div className="table-footer">
                <div className="results-count">
                  <p></p>
                </div>
                <div className="results-pagination">
                  <nav>
                    <ul className="pagination">
                      <li key={"9991"} className="page-item">
                        <button
                          className="prev page-link"
                          disabled={page <= 1}
                          onClick={() => changePage(page - 1)}
                        >
                          <img alt="" src={Arrow} />
                        </button>
                      </li>
                      {paginationElemnts(
                        data?.items,
                        page,
                        data?.totalCount,
                        changePage
                      )}
                      <li key={"9992"} className="page-item">
                        <button
                          className="next page-link"
                          disabled={
                            data?.items?.length < 10 ||
                            page === data?.totalCount / 10
                          }
                          onClick={() => changePage(page + 1)}
                        >
                          <img alt="" src={Arrow} />
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div> }
          </div>
        </div>
      </div>
    </>
  );
};
